import React, { useState, useMemo } from "react";
import { Button } from "@/components/ui/button";
import DynamicField, { validateFields } from "./DynamicField";
import { useI18n, labelOf } from "@/i18n/I18nProvider";

// Fallback default field set if admin form config not loaded yet
const FALLBACK_BASIC = {
  title: { en: "Hi! Let's get started." },
  subtitle: { en: "Just a few quick details before we personalise." },
  fields: [
    { key: "name", type: "text", label: { en: "Your name" }, placeholder: { en: "Enter your name" }, helper: {}, required: true, active: true, sort: 0 },
    { key: "age", type: "number", label: { en: "Age" }, placeholder: { en: "Enter your age" }, helper: {}, required: true, active: true, sort: 1 },
    { key: "phone", type: "tel", label: { en: "WhatsApp phone" }, placeholder: { en: "Enter your WhatsApp number(10 digits)" }, helper: { en: "We'll send your order here." }, required: true, active: true, sort: 2 },
  ],
};

export default function BasicDetailsStep({ value, onChange, onSubmit, t, formStep }) {
  const { lang } = useI18n();
  const step = formStep || FALLBACK_BASIC;
  const fields = useMemo(
    () => (step.fields || []).filter((f) => f.active !== false).sort((a, b) => (a.sort || 0) - (b.sort || 0)),
    [step]
  );
  const [errors, setErrors] = useState({});

  const submit = (e) => {
    e.preventDefault();
    const { errors: errs, ok } = validateFields(fields, value, t);
    setErrors(errs);
    if (ok) onSubmit();
  };

  return (
    <form onSubmit={submit} className="space-y-7 rise">
      <div>
        <p className="overline">{t("step.basic")}</p>
        <h2 className="editorial-h h-display mt-3 text-brand-dark">{labelOf(step.title, lang, t("basic.title"))}</h2>
        <p className="font-sans text-base text-brand-muted mt-4 leading-relaxed">
          {labelOf(step.subtitle, lang, t("basic.subtitle"))}
        </p>
      </div>

      <div className="space-y-5">
        {fields.map((f) => (
          <DynamicField
            key={f.key}
            field={f}
            value={value[f.key]}
            onChange={(v) => onChange({ [f.key]: v })}
            error={errors[f.key]}
            testIdPrefix="basic"
          />
        ))}
      </div>

      <Button
        type="submit"
        data-testid="basic-continue-btn"
        className="w-full h-14 rounded-full bg-brand-primary hover:bg-brand-primaryHover text-brand-bone font-semibold tracking-wide text-base shadow-soft"
      >
        {t("common.continue")} →
      </Button>
    </form>
  );
}
